import React, {  } from "react";
import { Form, Button } from 'antd';

import useStore from 'store/marketing-activities/apply-list';

import useBaseStore from 'store/base';

import SPDynamicFormRender from 'components/base/SPDynamicFormRender';

type Iprops = {
  data: any;
}

const From:React.FC<Iprops> = (props) => {
  const { data } = props;
  const [form] = Form.useForm();

  const { enums } = useBaseStore((state: any) => ({ ...state }));

  const { fetchList, searchData } = useStore(state => ({ ...state }));

  const handleSearch = () => {
    const values = form.getFieldsValue();
    const { page_size } = searchData as any || {};
    const params = { page_size, page: 1, ...values };
    fetchList(params);
  }

  const handleClear = () => {
    form.resetFields();
    const { page, page_size } = searchData as any;
    fetchList({ page, page_size });
  }

  return (
    <Form form={form}>
      <SPDynamicFormRender data={data} enums={enums} />
      <div style={{ marginBottom: 12 }}>
        <Button type="primary" onClick={handleSearch}>搜索</Button>
        <Button style={{ marginLeft: 12 }} onClick={handleClear}>清除</Button>
      </div>
    </Form>
  )
}

export default From;